const STORAGE_KEY = 'archestor-a11y'

function applyAccessibilityClass(enabled: boolean) {
  if (!import.meta.client) return
  document.documentElement.classList.toggle('a11y-mode', enabled)
}

function readStoredPreference(): boolean {
  if (!import.meta.client || !hasAcceptedConsent() || !hasFunctionalConsent()) return false

  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function persistPreference(enabled: boolean) {
  if (!import.meta.client || !hasAcceptedConsent() || !hasFunctionalConsent()) return

  try {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0')
  } catch {}
}

export function useAccessibility() {
  const enabled = useState('accessibility-mode', () => false)

  const initAccessibility = () => {
    const stored = readStoredPreference()
    enabled.value = stored
    applyAccessibilityClass(stored)
  }

  const toggleAccessibility = () => {
    enabled.value = !enabled.value
    applyAccessibilityClass(enabled.value)
    persistPreference(enabled.value)
  }

  return {
    accessibilityEnabled: enabled,
    initAccessibility,
    toggleAccessibility
  }
}